module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEYSURBVHgB7VIxTsNAENy98wOuoKBCa8v09DRBtEjkBxEvID9IfmB+EPIDClqEKeihxhInKgqkpI5iL3OS0yTmsBB0jLSaXe1o9rS3TBHkeT5omuYcqUN4Y8xDVVVll5YjBrNgoKolMy/BDjwAh/zCe1/GHkEiMsyyTMEFwm31HGLS9kcxE4FoEcQUHzZpddIpQHOWpuk99UDQQV9sarPVDzu4ph7Avuag4VdGgnimHsBnlK2+0yhMWtAPYOiX8G/0PRhHNQZftrUgPPWHbPQJ7uHGWrvz5Ye1yvG6nt4mPP6wdrlX1+5srVePCU9frPU7L4qNu9s/eCXVJ1WaszUj5Een729plza6oxWtTtQYYsOFauNCTX+NT8vbaCmbHhArAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m-6.png
// module id = yrKJ
// module chunks = 1